<template>
  <div class="home-page-wrapper">
    <HomeBanner :key="allSliders.length" :datas="allSliders" />
    <Social />
    <GettingStarted
      v-if="!loggedIn"
      :description="homeGettingStarted[0].description"
      :data="formattedGettingStartedData"
    />

    <DetailedProfile :data="formattedDetailInfo" :extraClass="['grey-bg']" />
    <ChatInfo
      :data="formattedChatInfoData"
      :extraClass="['text-content-right ']"
    />
    <TrackViews
      :image="generateImageUrl(homeTrackProfile.image)"
      :data="formattedTrackProfileData"
    />
    <SearchPlayers
      :data="formattedSearchPlayersData"
      :single="true"
      :extraClass="['no-padding-bottom']"
    />
    <SearchCoaches
      :data="formattedSearchCoachesData"
      :extraClass="['grey-bg']"
    />
    <SearchEvents :data="formattedSearchEventsData" />
    <NewsEvents
      v-if="necs[0].displayOnHomePage"
      :archive="necs[0].category"
      :title="necs[0].sectionTitle"
      :data="formattedNecsData"
    />
  </div>
</template>

<script>
import HomeBanner from "@/pageComponents/home/home-banner";
import DetailedProfile from "@/pageComponents/globalUi/multi-steps-info";
import ChatInfo from "@/pageComponents/globalUi/single-step-info";
import TrackViews from "@/pageComponents/home/track-views";
import GettingStarted from "@/pageComponents/home/getting-started";
import SearchPlayers from "@/pageComponents/globalUi/multi-steps-info";
import SearchCoaches from "@/pageComponents/globalUi/single-step-info";
import SearchEvents from "@/pageComponents/globalUi/event-section";
import NewsEvents from "@/pageComponents/home/news-events";
import Social from '@/pageComponents/social/Social'
import { mapGetters } from "vuex";
const HOME_STORE_KEY = "homeStore";

export default {
  name: "Home",
  async mounted() {
    await this.$store.dispatch(`${HOME_STORE_KEY}/getAllSliders`);
    await this.$store.dispatch(`${HOME_STORE_KEY}/getHomeTrackProfile`);
    await this.$store.dispatch(`${HOME_STORE_KEY}/getHomeGettingStarted`);
    await this.$store.dispatch(`${HOME_STORE_KEY}/getHomeDetailInfo`);
    await this.$store.dispatch(`${HOME_STORE_KEY}/getHomeSectionInfo`);
    await this.$store.dispatch(`${HOME_STORE_KEY}/getNecs`);
  },
  computed: {
    ...mapGetters({
      allSliders: `${HOME_STORE_KEY}/allSliders`,
      homeGettingStarted: `${HOME_STORE_KEY}/homeGettingStarted`,
      homeTrackProfile: `${HOME_STORE_KEY}/homeTrackProfile`,
      formattedGettingStartedData: `${HOME_STORE_KEY}/formattedGettingStartedData`,
      formattedTrackProfileData: `${HOME_STORE_KEY}/formattedTrackProfileData`,
      formattedDetailInfo: `${HOME_STORE_KEY}/formattedDetailInfo`,
      formattedChatInfoData: `${HOME_STORE_KEY}/formattedChatInfoData`,
      formattedSearchPlayersData: `${HOME_STORE_KEY}/formattedSearchPlayersData`,
      formattedSearchCoachesData: `${HOME_STORE_KEY}/formattedSearchCoachesData`,
      formattedSearchEventsData: `${HOME_STORE_KEY}/formattedSearchEventsData`,
      formattedNecsData: `${HOME_STORE_KEY}/formattedNecsData`,
      necs: `${HOME_STORE_KEY}/necs`
    }),
    loggedIn() {
      return Boolean(localStorage["user-permissions"]);
    }
  },
  components: {
    HomeBanner,
    DetailedProfile,
    ChatInfo,
    TrackViews,
    GettingStarted,
    SearchPlayers,
    SearchCoaches,
    SearchEvents,
    NewsEvents,
    Social
  },
  methods: {},
  data() {
    return {};
  }
};
</script>